"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var trophies = [
    {
        id: 'sword',
        name: 'Flaming Sword',
        description: 'Use this flaming sword to illuminate your studying path in your darkest hours!',
    },
    {
        id: 'axe',
        name: 'Golden Axe',
        description: 'This golden axe slices through the most difficult questions.',
    },
    {
        id: 'bow',
        name: 'Enchanted Bow',
        description: 'This will allow your studying to always be on target.',
    },
    {
        id: 'helmet',
        name: 'Golden Helm of Yduts',
        description: 'The golden helmet of Yduts is said to protect the user from any foul misconception.',
    },
    {
        id: 'hood',
        name: "Wizard's Hood",
        description: 'Only a true wizard can don this hood.',
    },
    {
        id: 'armor',
        name: 'Emerald Armor',
        description: 'Emerald body armor guards your heart from procrastination.',
    },
    {
        id: 'boots',
        name: 'Spring Heel Boots',
        description: 'These swift boots allow you to dance nimbly between cards.',
    },
    {
        id: 'shield',
        name: 'Polished Shield',
        description: 'Your studying progress reflects well on you, as does this shield.',
    },
    {
        id: 'book',
        name: 'Ancient Tome',
        description: "This tome contains all the knowledge you need to know for your exam. How'd it get here?",
    },
    {
        id: 'key',
        name: "Devil's Key",
        description: 'Keying in on your weak points can be a devil of a time.',
    },
    {
        id: 'bomb',
        name: 'Bomb',
        description: 'Your knowledge is expanding explosively!',
    },
    {
        id: 'compass',
        name: 'Magic Compass',
        description: "Looks like you're right on track for succeeding on your exam.",
    },
    {
        id: 'potion-red',
        name: 'Potion of Stamina',
        description: 'A potion to boost your studying stamina!',
    },
    {
        id: 'potion-blue',
        name: 'Potion of Magicka',
        description: 'A potion to boost the magic in your studying!',
    },
    {
        id: 'potion-green',
        name: 'Mysterious Potion',
        description: "Green drink? Well, hopefully it's healthy!",
    },
    {
        id: 'orange',
        name: 'Orange',
        description: 'Orange you glad to get this?',
    },
    {
        id: 'banana',
        name: 'Banana',
        description: 'Bana. Nana. Bananana. When does it stop?',
    },
    {
        id: 'carrot',
        name: 'Carrot',
        description: "I don't know if you carrot all, but I think you're an amazing studier.",
    },
    {
        id: 'bread',
        name: 'Bread',
        description: 'Bready or not, here you are!',
    },
    {
        id: 'chicken',
        name: 'Chicken',
        description: "Your studying prowess clearly shows you're no chicken.",
    },
];
exports.default = trophies;
//# sourceMappingURL=trophies.js.map